import React, { useRef, useState } from "react";
import CopyrightDialog from "@/react/Webshop/Components/CopyrightDialog";
const useCopyrightDialog = () => {
    const [open, setOpen] = useState(false);
    const touchTimerRef = useRef(null);
    const triggeredByTouchRef = useRef(false);
    const openCopyrightDialog = () => setOpen(true);
    const closeCopyrightDialog = () => setOpen(false);
    const clearTouchTimer = () => {
        if (touchTimerRef.current !== null) {
            window.clearTimeout(touchTimerRef.current);
            touchTimerRef.current = null;
        }
    };
    const getCopyrightTriggerProps = (props) => {
        const LONGPRESS_MS = 420; // tune 350–450ms
        return Object.assign(Object.assign({}, (props !== null && props !== void 0 ? props : {})), { onContextMenu: (event) => {
                var _a;
                // If we already handled via touch long-press, don’t double-open
                if (triggeredByTouchRef.current) {
                    triggeredByTouchRef.current = false;
                    event.preventDefault();
                    return;
                }
                (_a = props === null || props === void 0 ? void 0 : props.onContextMenu) === null || _a === void 0 ? void 0 : _a.call(props, event);
                event.preventDefault();
                openCopyrightDialog();
            }, onTouchStart: (event) => {
                var _a;
                (_a = props === null || props === void 0 ? void 0 : props.onTouchStart) === null || _a === void 0 ? void 0 : _a.call(props, event);
                // Don’t try to preventDefault here unless you really need to;
                // it can break scrolling/clicks unless you set touch-action etc.
                triggeredByTouchRef.current = false;
                clearTouchTimer();
                touchTimerRef.current = window.setTimeout(() => {
                    triggeredByTouchRef.current = true;
                    openCopyrightDialog();
                }, LONGPRESS_MS);
            }, onTouchMove: (event) => {
                var _a;
                (_a = props === null || props === void 0 ? void 0 : props.onTouchMove) === null || _a === void 0 ? void 0 : _a.call(props, event);
                // user is scrolling or moving finger -> cancel long press
                clearTouchTimer();
            }, onTouchEnd: (event) => {
                var _a;
                (_a = props === null || props === void 0 ? void 0 : props.onTouchEnd) === null || _a === void 0 ? void 0 : _a.call(props, event);
                clearTouchTimer();
            }, onTouchCancel: (event) => {
                var _a;
                (_a = props === null || props === void 0 ? void 0 : props.onTouchCancel) === null || _a === void 0 ? void 0 : _a.call(props, event);
                clearTouchTimer();
            } });
    };
    return {
        getCopyrightTriggerProps,
        openCopyrightDialog,
        closeCopyrightDialog,
        copyrightDialog: (React.createElement(CopyrightDialog, { open: open, onClose: closeCopyrightDialog })),
    };
};
export default useCopyrightDialog;
